import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { LayoutContainer } from "@/containers/Layout/Layout";
import { GlobalConfigProvider } from "@/hooks/useConfig";
import { AuthProvider } from "@/lib/auth/AuthStore";
import { GA_TRACKING_ID, gaPageView } from "@/lib/ga4";
import { AppDefaultStyle } from "@/themes/defaultStyle";
import { GlobalStyles } from "@/themes/Global.style";
import { ConfigProvider } from "antd";
import "antd/dist/reset.css"; // import '../themes/antd-custom.less'
import App from "next/app";
import Head from "next/head";
import { useRouter } from "next/router";
import Script from "next/script";
import { useEffect } from "react";
import { StyleSheetManager, ThemeProvider } from "styled-components";
import { default as themes } from "../themes";
import apiService from "@/lib/apiService/apiService";
import { RestfulApiProvider } from "@/lib/apiService/RestfulApiService";
import uiLibraryTheme from "@/themes/uiLibraryTheme";
import { CssBaseline, ThemeProvider as MuiThemeProvider } from "@mui/material";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { getCookies } from "cookies-next";
import { DefaultSeo } from "next-seo";
import { isInWebview } from "src/utils/misc";
import { getMe } from "../api/getMe";
import defaultSeoConfig from "../settings/next-seo.config";
import { solvookPageViewed } from "@/lib/mixpanels/mixpanel";
const KAKAO_JAVASCRIPT_SDK_KEY = process.env.NEXT_PUBLIC_KAKAO_JAVASCRIPT_SDK_KEY;
const Mixpanel_TOKEN = process.env.NEXT_PUBLIC_MIXPANEL_TOKEN;
const GOOGLE_TAG_MANAGER_ID = isInWebview() || process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID;
const queryClient = new QueryClient();
const MyApp = (param)=>{
    let { Component , pageProps , auth  } = param;
    const currentSelectedTheme = "defaultTheme";
    const currentTheme = themes[currentSelectedTheme];
    const router = useRouter();
    const asPath = router.asPath;
    useEffect(()=>{
        try {
            if (!window.Kakao.isInitialized() && window.Kakao) {
                // JavaScript key를 인자로 주고 SDK 초기화
                window.Kakao.init(KAKAO_JAVASCRIPT_SDK_KEY);
                ;
            // window.Kakao.init(process.env.NEXT_PUBLIC_KAKAO_JAVASCRIPT)
            }
        } catch (e) {
            ;
        }
    }, []);
    useEffect(()=>{
        gaPageView(asPath);
        solvookPageViewed(asPath);
    }, [
        asPath
    ]);
    var _Component_getLayout;
    const getLayout = (_Component_getLayout = Component.getLayout) !== null && _Component_getLayout !== void 0 ? _Component_getLayout : (page)=>/*#__PURE__*/ _jsx(LayoutContainer, {
            children: page
        });
    const isSignupPage = router.pathname.includes("/signup") || router.pathname.includes("/checkout");
    const jsonLdData = {
        "@context": "http://schema.org",
        "@type": "Organization",
        name: "쏠북",
        url: "https://solvook.com",
        sameAs: [
            "https://blog.naver.com/bookips"
        ]
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Head, {
                children: [
                    /*#__PURE__*/ _jsx("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"
                    }),
                    /*#__PURE__*/ _jsx("link", {
                        rel: "stylesheet",
                        type: "text/css",
                        href: "https://cdn.jsdelivr.net/gh/orioncactus/pretendard/dist/web/static/pretendard.css"
                    }),
                    /*#__PURE__*/ _jsx("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ _jsx("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com",
                        crossOrigin: "anonymous"
                    }),
                    /*#__PURE__*/ _jsx("link", {
                        href: "https://fonts.googleapis.com/css2?family=Montserrat:wght@900&display=swap",
                        rel: "stylesheet"
                    }),
                    /*#__PURE__*/ _jsx("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(jsonLdData)
                        }
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(DefaultSeo, {
                ...defaultSeoConfig,
                ...process.env.NEXT_PUBLIC_ENV !== "production" && {
                    dangerouslySetAllPagesToNoIndex: true,
                    dangerouslySetAllPagesToNoFollow: true
                }
            }),
            /*#__PURE__*/ _jsx(GlobalConfigProvider, {
                children: /*#__PURE__*/ _jsx(AuthProvider, {
                    initialValues: auth,
                    children: /*#__PURE__*/ _jsx(RestfulApiProvider, {
                        value: apiService,
                        children: /*#__PURE__*/ _jsx(ThemeProvider, {
                            theme: currentTheme,
                            children: /*#__PURE__*/ _jsx(StyleSheetManager, {
                                disableVendorPrefixes: true,
                                children: /*#__PURE__*/ _jsx(ConfigProvider, {
                                    theme: {
                                        token: {
                                            colorPrimary: currentTheme.primary[0],
                                            colorPrimaryText: currentTheme.text[0],
                                            borderRadius: 2
                                        },
                                        components: {
                                            Button: {
                                                colorPrimary: currentTheme.primary[0]
                                            }
                                        }
                                    },
                                    children: /*#__PURE__*/ _jsx(QueryClientProvider, {
                                        client: queryClient,
                                        children: /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsx(GlobalStyles, {}),
                                                /*#__PURE__*/ _jsx(AppDefaultStyle, {}),
                                                /*#__PURE__*/ _jsxs(MuiThemeProvider, {
                                                    theme: uiLibraryTheme,
                                                    children: [
                                                        /*#__PURE__*/ _jsx(CssBaseline, {}),
                                                        getLayout(/*#__PURE__*/ _jsx(Component, {
                                                            ...pageProps
                                                        }))
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx(ReactQueryDevtools, {
                                                    initialIsOpen: true
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    id: "overlay"
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Script, {
                id: "gtag-script",
                strategy: "afterInteractive",
                src: "https://www.googletagmanager.com/gtag/js?id=".concat(GA_TRACKING_ID)
            }),
            /*#__PURE__*/ _jsx(Script, {
                id: "gtag-init-script",
                strategy: "afterInteractive",
                dangerouslySetInnerHTML: {
                    __html: "\n            window.dataLayer = window.dataLayer || [];\n            function gtag(){dataLayer.push(arguments);}\n            gtag('js', new Date());\n            gtag('config', '".concat(GA_TRACKING_ID, "', {\n              page_path: window.location.pathname,\n            });\n          ")
                }
            }),
            "object" != "undefined" && !window.mixpanel && /*#__PURE__*/ _jsx(Script, {
                id: "mixpanel-init-script",
                strategy: "afterInteractive",
                dangerouslySetInnerHTML: {
                    __html: '\n              (function(f,b){if(!b.__SV){var e,g,i,h;window.mixpanel=b;b._i=[];b.init=function(e,f,c){function g(a,d){var b=d.split(".");2==b.length&&(a=a[b[0]],d=b[1]);a[d]=function(){a.push([d].concat(Array.prototype.slice.call(arguments,0)))}}var a=b;"undefined"!==typeof c?a=b[c]=[]:c="mixpanel";a.people=a.people||[];a.toString=function(a){var d="mixpanel";"mixpanel"!==c&&(d+="."+c);a||(d+=" (stub)");return d};a.people.toString=function(){return a.toString(1)+".people (stub)"};i="disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove".split(" ");\n            for(h=0;h<i.length;h++)g(a,i[h]);var j="set set_once union unset remove delete".split(" ");a.get_group=function(){function b(c){d[c]=function(){call2_args=arguments;call2=[c].concat(Array.prototype.slice.call(call2_args,0));a.push([e,call2])}}for(var d={},e=["get_group"].concat(Array.prototype.slice.call(arguments,0)),c=0;c<j.length;c++)b(j[c]);return d};b._i.push([e,f,c])};b.__SV=1.2;e=f.createElement("script");e.type="text/javascript";e.async=!0;e.src="undefined"!==typeof MIXPANEL_CUSTOM_LIB_URL?\n            MIXPANEL_CUSTOM_LIB_URL:"file:"===f.location.protocol&&"//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js".match(/^\\/\\//)?"https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js":"//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js";g=f.getElementsByTagName("script")[0];g.parentNode.insertBefore(e,g)}})(document,window.mixpanel||[]);\n            mixpanel.init(\''.concat(Mixpanel_TOKEN, '\', {debug: true, track_pageview: "full-url"});\n          \n  ')
                }
            }),
            /*#__PURE__*/ _jsx("noscript", {
                children: /*#__PURE__*/ _jsx("iframe", {
                    src: "https://www.googletagmanager.com/ns.html?id=".concat(GOOGLE_TAG_MANAGER_ID),
                    height: "0",
                    width: "0",
                    style: {
                        display: "none",
                        visibility: "hidden"
                    }
                })
            }),
            /*#__PURE__*/ _jsx(Script, {
                id: "google-tag-manager",
                dangerouslySetInnerHTML: {
                    __html: "\n        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n        })(window,document,'script','dataLayer', '".concat(GOOGLE_TAG_MANAGER_ID, "');\n        ")
                }
            }),
            /*#__PURE__*/ _jsx(Script, {
                type: "text/javascript",
                src: "//wcs.naver.net/wcslog.js"
            }),
            !isSignupPage && /*#__PURE__*/ _jsx(Script, {
                id: "wcs-nasa-script",
                strategy: "lazyOnload",
                children: '\n          if (!wcs_add) var wcs_add={};\n          wcs_add["wa"] = "s_1b6f4943c842";\n          if (!_nasa) var _nasa={};\n          if(window.wcs){\n            wcs.inflow();\n            wcs_do(_nasa);\n          }\n        '
            })
        ]
    });
};
MyApp.getInitialProps = async (appContext)=>{
    var _appContext_ctx, _appContext_ctx1;
    const appProps = await App.getInitialProps(appContext);
    const req = (_appContext_ctx = appContext.ctx) === null || _appContext_ctx === void 0 ? void 0 : _appContext_ctx.req;
    const res = (_appContext_ctx1 = appContext.ctx) === null || _appContext_ctx1 === void 0 ? void 0 : _appContext_ctx1.res;
    if (!req) return {
        ...appProps,
        auth: undefined
    };
    const { accessToken , session  } = getCookies({
        req,
        res
    });
    let auth = req === null || req === void 0 ? void 0 : req.auth;
    if (accessToken) {
        try {
            let response = await getMe(accessToken);
            auth = {
                ...auth,
                ...response
            } // auth 정보에 추가
            ;
        } catch (e) {
            ;
            ;
        }
    }
    return {
        ...appProps,
        auth: auth
    };
};
export default MyApp;
